import axios from "axios";

// Get API URL from environment variable or fallback based on environment
const API_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://a.z0n.net/api'
    : 'http://localhost:8000/api');

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

api.interceptors.request.use((config) => {
  // Try to get candidate token first, then fallback to regular token
  const candidateToken = localStorage.getItem("candidate_token");
  const token = localStorage.getItem("token");
  const authToken = candidateToken || token;
  
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  
  console.log('API Request:', {
    url: config.url,
    method: config.method,
    token: authToken ? 'Present' : 'Missing',
    headers: {
      'Authorization': authToken ? 'Bearer ***' : 'None',
      'Content-Type': config.headers['Content-Type'],
      'Accept': config.headers['Accept']
    }
  });
  
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export default api; 